import type {
    FileUploadSource
} from "../../type";
import {
    Camera as CameraIcon,
    Folder as FolderIcon,
    Image as ImageIcon,
    type LucideIcon
} from "lucide-react-native";

export const SOURCE_SHEET_ICONS: Record<FileUploadSource, LucideIcon> = {
    camera: CameraIcon,
    library: ImageIcon,
    files: FolderIcon
};

export const SOURCE_SHEET_LABELS: Record<"files" | "avatar", Record<FileUploadSource, Array<keyof NCoreUIKit.Translation>>> = {
    avatar: {
        library: [
            "file-upload-choose-from-library",
            "file-upload-choose-from-library-desc"
        ],
        camera: [
            "file-upload-take-photo",
            "file-upload-take-photo-desc"
        ],
        files: [
            "file-upload-files",
            "file-upload-files-desc"
        ]
    },
    files: {
        library: [
            "file-upload-library",
            "file-upload-library-desc"
        ],
        camera: [
            "file-upload-camera",
            "file-upload-camera-desc"
        ],
        files: [
            "file-upload-files",
            "file-upload-files-desc"
        ]
    }
};
